import { Subject } from 'rxjs'

const subject = new Subject()

export const uploadProgressService = {
  emitReload: (val) => subject.next(val),
  reload: () => subject.asObservable(),
}
